import { render, staticRenderFns } from "./chatbot-qa.vue?vue&type=template&id=7a7a5fd5"
import script from "./chatbot-qa.vue?vue&type=script&lang=js"
export * from "./chatbot-qa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports